// InfoTooltip component - displays an info icon with tooltip on hover
// Used to provide contextual help for metrics and dashboard elements

import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import '../../styles/components.css';

function InfoTooltip({ text, position = 'top' }) {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);
  
  // Handle touch events for mobile
  const handleTouch = (e) => {
    e.preventDefault();
    setIsVisible(!isVisible);
  };

  return (
    <div className="info-tooltip-container">
      <FontAwesomeIcon 
        icon={faCircleInfo}
        className="info-tooltip-icon"
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onTouchStart={handleTouch}
        role="button"
        tabIndex={0}
        aria-label="More information"
      />
      {isVisible && (
        <div className={`info-tooltip info-tooltip-${position}`}>
          <div className="info-tooltip-content">
            {text}
          </div>
        </div>
      )}
    </div>
  );
}

export default InfoTooltip;